import { forwardRef, Ref } from 'react';
import { useField } from 'formik';

import { Input, IInputProps } from 'shared/components/Input';

export const FormikInput = forwardRef(
  (
    { className, errorMessage, hasError, label, name, ...props }: IInputProps,
    ref?: Ref<HTMLInputElement>,
  ) => {
    const [field, meta] = useField(name);
    const { onChange, value } = field;
    const { error, touched } = meta;

    return (
      <Input
        {...field}
        {...props}
        className={className}
        data-qa={props['data-qa']}
        errorMessage={errorMessage || error}
        hasError={hasError || (touched && !!error)}
        label={label}
        name={name}
        onChange={props.onChange || onChange}
        ref={ref}
        value={value}
      />
    );
  },
);
